import { createTheme } from "@material-ui/core/styles";

/**
 * Maps the Talaera design tokens (src/styles/tokens.css) onto Material-UI v4.
 *
 * Until this theme existed, all MUI controls rendered Material's stock
 * palette (indigo primary, red 700 error, orange 500 warning) — which is how
 * off-brand colours kept leaking into surfaces like the toasts. Any MUI
 * control that today sets its colour explicitly (makeStyles overrides,
 * inline styles, scoped CSS) is unaffected; controls on MUI defaults go
 * on-brand.
 *
 * Note: the app also carries MUI v5 transitively via react-page (the content
 * editor). That island themes itself; this theme covers the v4 surface the
 * app owns.
 */
export const muiTheme = createTheme({
  palette: {
    primary: { main: "#25394d" }, // --Action-6
    secondary: { main: "#01bcd4" }, // --Action
    error: { main: "#c42b46" }, // --Error-6
    warning: { main: "#c74600" }, // --Warning-6
    success: { main: "#22ba7c" }, // --Success-Success
    info: { main: "#5d6d83" }, // --Grey-6
    text: {
      primary: "#424a59", // --grey-7-text-normal
      secondary: "#5d6d83", // --grey-6-text-medium
    },
  },
  typography: {
    fontFamily: "Lato, sans-serif", // --app-font-family
  },
  // The kit ui/Dialog overlay sits at z-index 99999 (--z-dialog). MUI v4's
  // stock scale tops out at 1500, so every portaled MUI surface painted
  // UNDER kit dialogs and each call site carried its own zIndex lift.
  // `modal` is the one key that governs them all: Select menus render via
  // Popover -> Modal (zIndex.modal), and lab Autocomplete's popper styles
  // itself to zIndex.modal too. Values mirror --z-dialog-popover in
  // src/styles/tokens.css (themes can't read CSS vars — keep in sync), and
  // snackbar/tooltip keep MUI's modal < snackbar < tooltip ordering.
  zIndex: {
    modal: 100000, // --z-dialog-popover
    snackbar: 100001,
    tooltip: 100002,
  },
  overrides: {
    // MUI's ButtonBase strips the native focus outline and expects the theme
    // to style keyboard focus — without this, Tabs, IconButtons and Buttons
    // take focus invisibly (WCAG 2.4.7).
    MuiButtonBase: {
      root: {
        "&.Mui-focusVisible": {
          outline: "2px solid #01bcd4", // --Action
          outlineOffset: "2px",
        },
      },
    },
  },
});
